import { magic } from '@gig/magic-sdk';
import { SESSION_START_EVENT, BETS_PLACED_EVENT, BET_WINS_EVENT } from '@gig/magic-messages';
import { SET_GAME_SESSION } from './game-session.constants.js';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const getInitialState = () => ({
  sessionStart: new Date(),
  betsPlaced: 0,
  betWins: 0
});
const getters = {
  betsPlaced: (state) => state.betsPlaced,
  betWins: (state) => state.betWins,
  sessionStart: (state) => state.sessionStart
};
const actions = {
  fetchGameSessionSummary(_0) {
    return __async(this, arguments, function* ({
      commit
    }) {
      try {
        const payload = yield magic.methods.users.getGameSessionSummary();
        if (payload.sessionStart && payload.betsPlaced) {
          commit(SET_GAME_SESSION, payload);
        }
        return payload;
      } catch (e) {
        console.error("Failed to get the game session data", e);
        return false;
      }
    });
  },
  setGameSessionSummary({ commit }, data) {
    commit(SET_GAME_SESSION, data);
  },
  resetGameSessionSummary({
    commit
  }) {
    commit(SET_GAME_SESSION, getInitialState());
  }
};
const gameSession = {
  namespaced: true,
  state: getInitialState(),
  actions,
  getters,
  mutations: {
    [SET_GAME_SESSION](state, payload) {
      state.sessionStart = payload.sessionStart;
      window.eventBus.publish(SESSION_START_EVENT, payload.sessionStart);
      state.betsPlaced = payload.betsPlaced;
      window.eventBus.publish(BETS_PLACED_EVENT, payload.betsPlaced);
      state.betWins = payload.betWins;
      window.eventBus.publish(BET_WINS_EVENT, payload.betWins);
    }
  }
};

export { actions, gameSession, getters };
